import Flashlight from './Flashlight';

export default Flashlight;
